import React from 'react'

import { Content, Text } from './HeroStyles'


const Hero = () => {
    return (
        <>
            <Content />
            <Text>Travel Junkies</Text>
        </>
    )
}

export default Hero